/// <amd-module name="Build/Common/Library/Duration" />
export function getDurationStats(milliseconds: number) {
    milliseconds = Math.abs(milliseconds);
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    return {
        days: days,
        hours: hours % 24,
        minutes: minutes % 60,
        seconds: seconds % 60
    };
}

export function padZeroes(number: number, times: number = 2) {
    let result = number + "";
    while (result.length < times) {
        result = "0" + result;
    }

    return result;
}
